import React, { useEffect, useState } from 'react';
import { Container } from '../components/common/Container';
import { Eyebrow, Badge } from '../components/common/Badge';
import { Icon } from '../lib/icons';
import { dataService } from '../services/dataService';
import { useLanguage } from '../context/LanguageContext';

export function Eventi() {
  const [data, setData] = useState(null);
  const [active, setActive] = useState('all');
  const { lang } = useLanguage();
  useEffect(() => { dataService.getEvents().then(setData); }, [lang]);
  if (!data) return null;

  const featured = active === 'all' ? data.featured : data.featured.filter((f) => f.cat === active);

  return (
    <div className="pb-20 pt-8">
      {/* HERO */}
      <Container>
        <section className="relative overflow-hidden rounded-card">
          <img src={data.hero.image} alt="Eventi" className="h-[380px] w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/25 to-transparent" />
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-lg px-8 md:px-12">
              <Eyebrow className="rounded-btn bg-white/85 px-3 py-1">{data.hero.eyebrow}</Eyebrow>
              <h1 className="mt-4 font-display text-4xl leading-[1.1] text-white md:text-[48px]">
                {data.hero.title.map((l, i) => <span key={`h-${i}`} className="block">{l}</span>)}
              </h1>
              <span className="mt-5 block h-px w-12 bg-white/70" />
              <p className="mt-5 max-w-md font-sans text-base text-white/90">{data.hero.text}</p>
            </div>
          </div>
        </section>
      </Container>

      {/* FILTERS */}
      <Container className="mt-8">
        <div className="no-scrollbar -mx-6 flex gap-3 overflow-x-auto px-6 pb-2">
          {data.filters.map((f) => (
            <button key={f.id} onClick={() => setActive(f.id)}
              className={`flex h-11 shrink-0 items-center gap-2 rounded-btn border px-4 text-sm transition-colors ${active === f.id ? 'border-paelbi-brown bg-paelbi-brown text-white' : 'border-paelbi-line bg-white text-paelbi-ink/80 hover:border-paelbi-brown/50'}`}>
              {f.icon && <Icon name={f.icon} size={18} strokeWidth={1.75} />}{f.label}
            </button>
          ))}
        </div>
      </Container>

      {/* FEATURED */}
      <Container className="mt-10">
        <h2 className="font-display text-2xl text-paelbi-ink md:text-[28px]">Eventi in evidenza</h2>
        <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-3">
          {featured.map((e) => (
            <article key={e.id} className="group flex flex-col overflow-hidden rounded-card border border-paelbi-line bg-white shadow-card transition-all hover:-translate-y-1 hover:shadow-soft">
              <div className="relative">
                <img src={e.image} alt={e.title} loading="lazy" className="h-44 w-full object-cover" />
                <span className="absolute bottom-3 left-3"><Badge className="bg-white/90">{e.badge}</Badge></span>
              </div>
              <div className="flex flex-1 flex-col p-6">
                <h3 className="font-display text-lg text-paelbi-ink">{e.title}</h3>
                <div className="mt-3 space-y-1.5 font-sans text-sm text-paelbi-ink/70">
                  <p className="flex items-center gap-2"><Icon name="calendar" size={15} className="text-paelbi-brown" />{e.date} · {e.time}</p>
                  <p className="flex items-center gap-2"><Icon name="mapPin" size={15} className="text-paelbi-brown" />{e.place}</p>
                </div>
                <p className="mt-3 flex-1 font-sans text-sm leading-relaxed text-paelbi-ink/70">{e.text}</p>
              </div>
            </article>
          ))}
        </div>
      </Container>

      {/* AGENDA */}
      <Container className="mt-14">
        <h2 className="font-display text-2xl text-paelbi-ink md:text-[28px]">Prossimi appuntamenti</h2>
        <div className="mt-6 overflow-hidden rounded-card border border-paelbi-line bg-white shadow-card">
          {data.agenda.map((a, i) => (
            <a href="#" key={a.id} className={`flex items-center gap-5 p-4 transition-colors hover:bg-paelbi-bg ${i > 0 ? 'border-t border-paelbi-line' : ''}`}>
              <div className="flex h-16 w-16 shrink-0 flex-col items-center justify-center rounded-[12px] bg-paelbi-bg2">
                <span className="font-display text-2xl leading-none text-paelbi-ink">{a.day}</span>
                <span className="mt-1 font-sans text-[10px] font-semibold uppercase tracking-widest text-paelbi-brown">{a.month}</span>
              </div>
              <div className="flex-1">
                <h3 className="font-display text-base text-paelbi-ink">{a.title}</h3>
                <p className="mt-0.5 flex items-center gap-1.5 font-sans text-xs text-paelbi-ink/60"><Icon name="mapPin" size={13} />{a.place}</p>
              </div>
              <span className="flex items-center gap-1.5 font-sans text-sm text-paelbi-ink/70"><Icon name="clock" size={14} />{a.time}</span>
              <Icon name="chevronRight" size={18} className="text-paelbi-ink/50" />
            </a>
          ))}
        </div>
      </Container>
    </div>
  );
}

export default Eventi;
